import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThreeScene from './ThreeScene';
import './MainPage.css';

const MainPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="main-page">
      <div className="lights-container">
        <video
          className="christmas-lights-video"
          autoPlay
          loop
          muted
          playsInline
          src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`}
        >
          <source src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="three-container" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0
      }}>
        <ThreeScene />
      </div>

      <header className="main-header">
        <h1 className="main-title">Welcome to the Christmas Tree 🎄</h1>
        <p>Bring joy and magic to your Christmas tree!</p>
      </header>

      <div className="main-buttons">
        <button onClick={() => navigate('/register')} className="main-button">
          🎄 Create My Tree
        </button>
        <button onClick={() => navigate('/login')} className="main-button">
          🔑 Login
        </button>
      </div>
    </div>
  );
};

export default MainPage;